import { render, staticRenderFns } from "./summation_method.vue?vue&type=template&id=5c46392c"
import script from "./summation_method.vue?vue&type=script&lang=js"
export * from "./summation_method.vue?vue&type=script&lang=js"
import style0 from "./summation_method.vue?vue&type=style&index=0&id=5c46392c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports